import React from 'react';
import {
	ITag,
	ITagItemSuggestionStyles,
	TagItemSuggestionCompat as TagItemSuggestion,
} from 'components/FluentUICompat';

/**
 * This must not be memoized because the app throws an error if we try using
 * hooks.
 */
const styles: ITagItemSuggestionStyles = {
	suggestionTextOverflow: {maxWidth: '65vw'},
};

export function BaselineSuggestion(props: ITag): React.ReactElement {
	return <TagItemSuggestion styles={styles}>{props.name}</TagItemSuggestion>;
}
